/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quiet_Dusty_Ram_WakeInputs */

const en_quiet_dusty_ram_wake = /** @type {(inputs: Quiet_Dusty_Ram_WakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This segment no longer exists in the organization's attributes. Remove it from this report.`)
};

const de_quiet_dusty_ram_wake = /** @type {(inputs: Quiet_Dusty_Ram_WakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Segment existiert nicht mehr in den Attributen der Organisation. Entferne es aus diesem Bericht.`)
};

/**
* | output |
* | --- |
* | "This segment no longer exists in the organization's attributes. Remove it from this report." |
*
* @param {Quiet_Dusty_Ram_WakeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quiet_dusty_ram_wake = /** @type {((inputs?: Quiet_Dusty_Ram_WakeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quiet_Dusty_Ram_WakeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quiet_dusty_ram_wake(inputs)
	return de_quiet_dusty_ram_wake(inputs)
});